<template>
    <div id="tutorial">
        <!-- Background -->
        <div class="bg" @click="setTutorialVisible(false)"></div>

        <div class="tutorial-panel">
            <!-- Close-Button -->
            <button class="exit fab m" @click="setTutorialVisible(false)">
                <img :src="getMedia('icons/close.svg')" alt="">
            </button>

            <!-- Steps -->
            <TutorialSteps
                :pageIndex="pageIndex"
                :pages="pages"/>

            <!-- Navigation -->
            <TutorialNavigation
                :pageIndex="pageIndex"
                :pageCount="pageCount"
                :setActivePage="setActivePage"
                :setTutorialVisible="setTutorialVisible"/>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import pages from '@/assets/tutorial/tutorial.json';
import TutorialNavigation from './TutorialNavigation.vue';
import TutorialSteps from './TutorialSteps.vue';
import { useStore } from '@/store';
import { storeToRefs } from 'pinia';
import { getMedia } from '@/util';

const store = useStore();
const { isTutorialVisible } = storeToRefs(store);

const pageIndex = ref(0);
const pageCount = computed(() => pages.length);

watch(isTutorialVisible, (newVal) => {
    store.setFirstTimeTutorial(false);
    if (newVal) 
        pageIndex.value = 0;
});

function setActivePage(index: number) {
    if (index < 0 || index >= pageCount.value) 
        return;

    pageIndex.value = index;
}

function setTutorialVisible(visible: boolean) {
    store.setTutorialVisible(visible);
}
</script>

<style scoped lang="scss">
#tutorial {
    position: absolute;
    z-index: 3;
    inset:0;
    display: flex;
    justify-content: center;
    align-items: center;

    .bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(2px);
    }

    .tutorial-panel {
        position: absolute;
        border-radius: 0.25rem;
        overflow: hidden;
        max-width: 500px;

        display: flex;
        flex-direction: column;

        background: var(--bg-light);
    }

}

/*MOBILE*/
@media (max-width: 900px) {
    .tutorial-panel{
        inset: 2rem !important;
    }

    .media-wrapper {
        height: 50% !important;
    }
}
</style>